import React from 'react';
import { Components, Theme } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export const MuiAccordion = {
  defaultProps: {
    disableGutters: true,
    elevation: 0
  },
  styleOverrides: {
    root: ({ theme }) => ({
      '&.MuiPaper-outlined': {
        borderRadius: 8,
        border: '1px solid',
        borderColor: theme.palette.neutral.outlineVariant,
      },
      '&:before': {
        display: 'none'
      }
    }),
  }
} as Components<Theme>['MuiAccordion'];

export const MuiAccordionSummary = {
  defaultProps: {
    expandIcon: <ExpandMoreIcon />,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(0.5, 1),
      borderRadius: 4,
      gap: theme.spacing(1),
      minHeight: 40,
      alignItems: 'flex-start',
      ...theme.createStateLayer('transparent'),
      '& .MuiCheckbox-root input': {
        zIndex: 2
      }
    }),
    content: {
      margin: 0,
      flexDirection: 'column',
      overflow: 'hidden',
    },
    expandIconWrapper: ({ theme }) => ({
      marginTop: theme.spacing(0.5),
      color: theme.palette.neutral.onSurfaceVariant,
    })
  },
} as Components<Theme>['MuiAccordionSummary'];

export const MuiAccordionDetails = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(1),
    }),
  },
} as Components<Theme>['MuiAccordionDetails'];

export const MuiAccordionActions = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(0),
    }),
  },
} as Components<Theme>['MuiAccordionActions'];